import React, { useState, useEffect } from 'react';
import { Button } from '../';
import { DatePicker } from 'antd';
import { FilePdfOutlined, FileExcelOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import './ReportDateRangePicker.scss';

const { RangePicker } = DatePicker;

export const ReportDateRangePicker = ({ buttonText = 'Create Report' }) => {
    const today = dayjs();
    const oneMonthAgo = today.subtract(1, 'month');

    useEffect(() => {
        // Set the initial date range in the date picker
        window.reportingDateRange = {
            from: oneMonthAgo.format('YYYY-MM-DD'),
            to: today.format('YYYY-MM-DD'),
        };
    }, [oneMonthAgo, today]);

    const handleDateChange = (dates) => {
        if (dates?.[0] && dates?.[1]) {
            window.reportingDateRange = {
                from: dates[0].format('YYYY-MM-DD'),
                to: dates[1].format('YYYY-MM-DD'),
            };
        }
    };

    return (
        <div className="report-date-range-picker">
            <RangePicker defaultValue={[oneMonthAgo, today]} onChange={handleDateChange} format="MM-DD-YYYY" />
            <Button type="primary" onClick={() => window.buildReport()}>
                {buttonText}
            </Button>
            <Button
                type="primary"
                icon={<FilePdfOutlined />}
                onClick={() => window.generatePDF()}
                className="button button--primary"
            >
                Download Report PDF
            </Button>
            <Button
                type="primary"
                icon={<FileExcelOutlined />}
                onClick={() => window.handleReportGeneration()}
                className="button button--primary"
            >
                Download Report CSV
            </Button>
        </div>
    );
};
